import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { DialogManualBookingsService } from '@app/shared/services/manual-bookings/dialog-manual-bookings.service';
import { ManualBooking, ManualBookingsService } from '@app/shared/services/manual-bookings/manual-bookings.service';
import { ReservationService } from '@app/shared/services/reservation/reservation.service';
import { ThreadService } from '@app/shared/services/thread/thread.service';

@Component({
  standalone: false,
  selector: 'sbnb-dashboard-dialog',
  templateUrl: './dashboard-dialog.component.html',
  styleUrls: ['./dashboard-dialog.component.scss'],
})
export class DashboardDialogComponent implements OnInit {
  sidebar = ['Guest Insights', 'Reservation Details', 'Conversation', 'Activity', 'Tasks'];
  activeItem = 'Guest Insights';

  threadUuid: string;
  thread: any;
  reservations: any;
  messages: any;
  tasks: any;

  perms$ = this.userPermissionsService;
  Features = Features;

  constructor(
    public dialogRef: MatDialogRef<DashboardDialogComponent>,
    private threadService: ThreadService,
    private reservationService: ReservationService,
    private userPermissionsService: UserPermissionsService,
    private authService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly manualBookingsService: ManualBookingsService,
    private readonly dialogManualBookingsService: DialogManualBookingsService
  ) { }

  ngOnInit() {
    this.threadUuid = this.data.threadUuid;

    this.getReservations();
    this.activeItem = 'Reservation Details';
    this.sidebar = ['Reservation Details'];

    this.userPermissionsService.hasAccessTo(Features.PERM_INBOX).subscribe((res) => {
      if (res) {
        this.sidebar = ['Guest Insights'];
        this.sidebar.push('Reservation Details');
        this.sidebar.push('Conversation');
        this.sidebar.push('Activity');
        this.getThread();
        this.getMessages();
      }
    });

    this.userPermissionsService.hasAccessTo(Features.PERM_TASKS).subscribe((res) => {
      if (res) {
        this.sidebar.push('Tasks');
      }
    });
  }

  getThread() {
    this.threadService.getThread(this.threadUuid).subscribe((res) => {
      this.thread = res;
    });
  }

  getReservations() {
    this.reservationService.getReservationsForThread(this.threadUuid).subscribe((res) => {
      this.reservations = res;
    });
  }

  getMessages() {
    this.threadService.getMessages(this.threadUuid).subscribe((res) => {
      this.messages = res;
    });
  }

  editReservation() {
    const manualReservationId = this.reservations[0].uuid;

    this.manualBookingsService
      .fetchBooking(manualReservationId, this.reservations[0].platform)
      .subscribe((booking: ManualBooking) => {
        this.dialogManualBookingsService
          .openDialog(true, 'update', booking, booking.checkInDate, booking.checkOutDate)
          .subscribe((res) => { });
      });
  }
}
